import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

function Insights() {

  const [posts, setPosts] = useState([]);

  // FETCH POSTS
  const getPosts = async () => {

    try {

      const res = await axios.get(
        "http://localhost:5000/api/posts"
      );

      // ONLY PUBLISHED POSTS
      const publishedPosts = res.data.filter(
        post => post.status === "Published"
      );

      setPosts(publishedPosts);

    } catch (err) {

      console.log(err);

    }

  };

  useEffect(() => {

    getPosts();

  }, []);

  return (
    <section className="min-h-screen bg-[#F8F8F8] py-24 px-6 md:px-16">

      {/* HEADER */}
      <div className="max-w-7xl mx-auto mb-16">

        <p className="uppercase tracking-[6px] text-yellow-600 font-semibold mb-4">
          Insights & Legal Knowledge
        </p>

        <h1 className="text-5xl md:text-6xl font-bold text-[#0B1C39] leading-tight">
          Articles, Legal Guides & Updates
        </h1>

      </div>

      {/* POSTS GRID */}
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-10">

        {posts.map((post) => (

          <div
            key={post.id}
            className="bg-white rounded-[28px] overflow-hidden shadow-lg border border-gray-100 hover:-translate-y-2 transition duration-300"
          >

            {/* IMAGE */}
            <img
              src={`http://localhost:5000${post.featured_image}`}
              alt={post.title}
              className="w-full h-[240px] object-cover"
            />

            {/* CONTENT */}
            <div className="p-8">

              {/* CATEGORY */}
              <p className="uppercase tracking-[4px] text-yellow-600 text-sm font-semibold mb-3">
                {post.category}
              </p>

              {/* TITLE */}
              <h2 className="text-2xl font-bold text-[#0B1C39] leading-snug mb-4">
                {post.title}
              </h2>

              {/* EXCERPT */}
              <p className="text-gray-600 leading-relaxed mb-6">
                {post.excerpt}
              </p>

              {/* BUTTON */}
              <Link
                to={`/insights/${post.slug}`}
                className="text-[#0B3D91] font-semibold hover:underline"
              >
                Read Article →
              </Link>

            </div>

          </div>

        ))}

      </div>

    </section>
  );
}

export default Insights;